exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ACEntranceBox {\n  text-align: center;\n}\n.ACEntranceBox h3 {\n  color: #333;\n  font-size: 0.2rem;\n  padding: 0.4rem 0;\n  margin: 0;\n}\n.ACEntranceBox img {\n  width: 2rem;\n}\n.ACEntranceBox .btnBOx {\n  padding: 0 0.24rem;\n  margin-top: 0.4rem;\n}\n.ACEntranceBox .btnBOx .am-button-primary {\n  margin-bottom: 0.16rem;\n}\n.ACEntranceBox .btnBOx .xiazai {\n  color: #289BF8;\n  font-size: 0.14rem;\n  margin-top: 0.24rem;\n  display: block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/authCertificateCompact/ACEntrance/index.less
// module id = 879
// module chunks = 0